import type { ReactNode } from "react";

import styles from "./style.module.scss";

interface PermissionCardProps {
    icon: string;
    title: string;
    description?: string;
    children: ReactNode;
}

const PermissionCard = ({ icon, title, description, children }: PermissionCardProps) => {
    return (
        <div className={styles["permission-card"]}>
            <div className={styles["header"]}>
                <div className={styles["title-section"]}>
                    <span className={styles["icon"]}>{icon}</span>
                    <h4 className={styles["title"]}>{title}</h4>
                </div>
                {description && <p className={styles["description"]}>{description}</p>}
            </div>
            <div className={styles["content"]}>{children}</div>
        </div>
    );
};

export default PermissionCard;
